'use strict';

import './styles.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({
    disable: function() {
    let maxWidth = 800;
    return window.innerWidth < maxWidth;
  },
    once: false,
    mirror: true,
    duration: 1000
});
AOS.refresh();

// Mobile Menu Toggle
const mobileMenu = document.getElementById('mobileNav');
const navBar = document.getElementById('navBar');
const hamburgerMenu = document.getElementById('menuBtn');
const socialIcons = document.getElementById('socialIcons');

hamburgerMenu.addEventListener('click', () => {
    if (mobileMenu.classList.contains('hidden') && socialIcons.classList.contains('hidden')) {
        mobileMenu.classList.replace('hidden', 'flex') && socialIcons.classList.replace('hidden', 'flex');
    } else {
        mobileMenu.classList.replace('flex', 'hidden') && socialIcons.classList.replace('flex', 'hidden');
    }
})

hamburgerMenu.addEventListener('click', () => {
    navBar.classList.toggle('bg-gray-100');
})

// TypeWriter Effect (ES6 Code)
class TypeWriter {
    constructor(txtElement, words, wait = 3000) {
        this.txtElement = txtElement;
        this.words = words;
        this.txt = '';
        this.wordIndex = 0;
        this.wait = parseInt(wait, 10);
        this.type();
        this.isDeleting = false;
    }

    type() {
        // Current index of word
        const current = this.wordIndex % this.words.length;
        // Get full text of current word
        const fullTxt = this.words[current];

        // Check if deleting
        if (this.isDeleting) {
            // Remove char
            this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
            // Add char
            this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        // Insert txt into element
        this.txtElement.innerHTML = `<span class="txt">${this.txt}</span>`;

        // Initial Type Speed
        let typeSpeed = 300;

        if (this.isDeleting) {
            typeSpeed /= 2;
        }

        // If word is complete
        if (!this.isDeleting && this.txt === fullTxt) {
            // Make pause at end
            typeSpeed = this.wait;
            // Set delete to true
            this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
            this.isDeleting = false;
            // Move to next word
            this.wordIndex++;
            // Pause before start typing
            typeSpeed = 500;
        }

        setTimeout(() => this.type(), typeSpeed);
    }
}

// Init On DOM Load
document.addEventListener('DOMContentLoaded', init);

// Init App
function init() {
    const txtElement = document.querySelector('.txt-type');
    const words = JSON.parse(txtElement.getAttribute('data-words'));
    const wait = txtElement.getAttribute('data-wait');
    // Init TypeWriter
    new TypeWriter(txtElement, words, wait);
}


//Dark Mode Toggle

const getHtml = document.querySelector('html');
const sunIcon = document.querySelector('#sun');
const moonIcon = document.querySelector('#moon');

sunIcon.addEventListener('click', () => {
    sunIcon.style.display = 'none';
    moonIcon.style.display = 'inline-block';
    getHtml.classList.add('dark');
})

moonIcon.addEventListener('click', () => {
    moonIcon.style.display = 'none';
    sunIcon.style.display = 'inline-block';
    getHtml.classList.remove('dark');
})